export default {
  breadcrumb: {
    studies: 'スタディ',
    newStudy: '新規スタディ',
  },
  hero: {
    step: 'ステップ 01',
    methodology: '手法',
    title: 'このスタディをどのように実行しますか？',
    description:
      '各手法によって、以降のセットアップの形 — スイープできるパラメータ、設計点のサンプリング方法、実行が生成するもの — が決まります。これは後から変更できますが、以降のジャーニーは選択に合わせて調整されます。',
  },
  comingSoon: '近日公開',
  methods: {
    doe: {
      title: '実験計画法',
      subtitle: 'すべての組み合わせを実行',
      description:
        '設定したすべての離散値の直積（デカルト積）を取ります。各組み合わせが1つの CFD ケースになります。どの運転条件が重要かをすでに把握している場合に最適です。',
      bullet1: '離散＋リストパラメータ',
      bullet2: '予測可能な実行回数',
      bullet3: '結果テーブル＋スイープチャート',
      diagramCaption: '直交グリッド · n = 30',
    },
    surrogate: {
      title: 'サロゲートモデル',
      subtitle: '高速な予測器を訓練',
      description:
        '範囲全体を準ランダムにサンプリングし、ミリ秒単位でクエリできるガウス過程サロゲートを適合させます。目的関数を追加すると、多目的ベイズ最適化が有効になります。',
      bullet1: '範囲パラメータ',
      bullet2: 'GP モデル＋パレートフロント',
      bullet3: '適応的バッチ選択',
      diagramCaption: 'Sobol · n = 16 · GP 適合',
    },
    gci: {
      title: 'グリッド収束指数',
      subtitle: 'メッシュ独立性スタディ',
      description:
        '粗い・中間・細かいグリッドにわたってメッシュ解像度をスイープし、リチャードソン外挿を用いて離散化誤差を推定し、グリッド収束指数を報告します。',
      bullet1: '固定運転点',
      bullet2: '3段階のメッシュ細分化レベル',
      bullet3: '離散化誤差の限界',
      diagramCaption: 'リチャードソン外挿',
    },
  },
  footer: {
    selectingMethod: '手法を選択',
    rest: 'すると下書きが作成され、ジャーニーが開きます — 診断 · メッシュ · シミュレーション · 分析。無効な手法はロードマップに掲載されています。',
    back: '戻る',
    creating: '作成中',
    continue: '続行',
  },
} as const;
